import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconAspectRatio43: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconAspectRatio43"><Path d="M2 4H22V20H2V4Z" fill="currentColor"/></CentralIconBase>;
});

export default IconAspectRatio43;
